import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'manage-insurances';

export const MANAGE_INSURANCES_ACTION_TYPES = {
  SAVE_PATIENT_INSURANCES: `${actionsScope}/save-patient-insurances`,
  DOWNLOAD_PATIENT_INSURANCES_DATA: `${actionsScope}/download-patient-insurances-data`,
  SET_INSURANCE_RELATED_DATA_FETCHING: `${actionsScope}/set-insurance-related-data-fetching`,
  UPLOAD_INSURANCE_CARD: `${actionsScope}/upload-insurance-card`,
  SET_UPLOAD_INSURANCE_CARD_MODAL_DATA: `${actionsScope}/set-upload-insurance-card-modal-data`,
  UPLOAD_MAIN_INSURANCE_CARD: `${actionsScope}/upload-main-insurance-card`,
  RUN_MANUAL_ELIGIBILITY_ACTIVATION: `${actionsScope}/run-manual-eligibility-activation`,
  CLEAR_MANAGE_INSURANCE_RELATED_DATA: `${actionsScope}/clear-manage-insurance-related-data`,
  DOWNLOAD_TO_DO_TASK_INSURANCES_DATA: `${actionsScope}/download-to-do-task-insurances-data`,
  SAVE_TO_DO_INSURANCES_DATA: `${actionsScope}/save-to-do-insurances-data`,
  SET_INSURANCE_TO_DO_TASK_COMPLETING: `${actionsScope}/set-insurance-to-do-task-completing`,
};

export const manageInsurancesActions = {
  savePatientInsurances: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.SAVE_PATIENT_INSURANCES,
  ),
  downloadPatientInsurancesData: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_PATIENT_INSURANCES_DATA,
  ),
  setInsuranceRelatedDataFetching: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_RELATED_DATA_FETCHING,
  ),
  uploadInsuranceCard: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_INSURANCE_CARD,
  ),
  setUploadInsuranceCardModalData: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.SET_UPLOAD_INSURANCE_CARD_MODAL_DATA,
  ),
  uploadMainInsuranceCard: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_MAIN_INSURANCE_CARD,
  ),
  runManualEligibilityActivation: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.RUN_MANUAL_ELIGIBILITY_ACTIVATION,
  ),
  clearManageInsuranceRelatedData: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.CLEAR_MANAGE_INSURANCE_RELATED_DATA,
  ),
  downloadToDoTaskInsurancesData: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_TO_DO_TASK_INSURANCES_DATA,
  ),
  saveToDoInsurancesData: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.SAVE_TO_DO_INSURANCES_DATA,
  ),
  setInsuranceToDoTaskCompleting: createAction(
    MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_TO_DO_TASK_COMPLETING,
  ),
};



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/actions/manage-insurances-actions.js